import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'ramda';

import { getEstimateWithParameters, getEstimationSuburban } from '../../../actions/estimation';
import { setPreciseFiltersState } from '../../../actions/preciseFilters';
import { TThunkDispatch } from '../../../types/redux';
import { selectPreciseFiltersState } from '../../../selectors/preciseFilters';
import { setQueryParams, updateUrl } from '../../../actions/page';
import { selectIsSuburban } from '../../../selectors/filters';

export const useHandleResetPreciseFilters = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const preciseFiltersState = useSelector(selectPreciseFiltersState);
  const isSuburban = useSelector(selectIsSuburban);

  return React.useCallback(async () => {
    /** Подстраховка. коллбек не вызывается вообще, если фильтры пусты */
    /* istanbul ignore if */
    if (isEmpty(preciseFiltersState)) {
      return;
    }

    dispatch(setPreciseFiltersState({}));
    /**
     * При ручном изменении фильтров сбрасываем offerId и estimationId, т.к это уже не оценка по офферу в чистом виде
     * */
    dispatch(setQueryParams({ offerId: undefined, estimationId: undefined }));
    dispatch(updateUrl());

    await dispatch(isSuburban ? getEstimationSuburban() : getEstimateWithParameters());
  }, [dispatch, isSuburban, preciseFiltersState]);
};
